import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const HomeView = styled.section`
	width: 100%;
	max-width: 100%;
	min-width: 0;
	overflow-x: clip;
	min-height: min-content;
	background:
		linear-gradient(
			103deg,
			transparent 0%,
			transparent 31%,
			rgba(176, 38, 255, 0.2) 44%,
			rgba(255, 77, 242, 0.12) 54%,
			transparent 71%
		),
		linear-gradient(
			116deg,
			transparent 0%,
			transparent 54%,
			rgba(255, 211, 107, 0.06) 64%,
			transparent 78%
		);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding-bottom: 4px;
		overflow-x: visible;
	}
`;

export const LoungeMood = styled.section`
	min-width: 0;
	max-width: 100%;
	overflow-x: clip;
	min-height: 94px;
	padding: 18px min(5vw, 64px);
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 22px;
	background:
		linear-gradient(
			103deg,
			transparent 0%,
			transparent 34%,
			rgba(176, 38, 255, 0.18) 47%,
			rgba(255, 77, 242, 0.1) 56%,
			transparent 72%
		),
		radial-gradient(circle at 18% 45%, rgba(255, 77, 242, 0.18), transparent 26%),
		radial-gradient(circle at 74% 15%, rgba(176, 38, 255, 0.2), transparent 30%),
		linear-gradient(135deg, rgba(9, 4, 15, 0.9), rgba(2, 1, 6, 0.88));
	border-bottom: 1px solid rgba(246, 142, 255, 0.13);

	h2 {
		margin-bottom: 0;
		font-family: ${THEME.fontApp};
		font-size: clamp(1.55rem, 3.2vw, 2.55rem);
		font-weight: 800;
		line-height: 1.12;
		letter-spacing: 0;
		text-shadow: 0 0 18px rgba(255, 77, 242, 0.28);

		span {
			color: #fff;
			background: ${THEME.gradientHighlight};
			-webkit-background-clip: text;
			background-clip: text;
			-webkit-text-fill-color: transparent;
			filter: drop-shadow(0 0 12px rgba(255, 77, 242, 0.42));
		}
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		min-height: auto;
		align-items: flex-start;
		flex-direction: column;
		justify-content: center;
		gap: 14px;
		padding: 18px ${THEME.mobileGutter};

		h2 {
			font-size: clamp(1.42rem, 5.2vw, 1.68rem);
			line-height: 1.14;
		}
	}
`;

export const SurpriseAction = styled.button`
	min-height: 44px;
	border: 1px solid rgba(255, 255, 255, 0.16);
	border-radius: 999px;
	padding: 0 18px;
	display: inline-flex;
	align-items: center;
	gap: 9px;
	color: #fff7ff;
	font-family: ${THEME.fontApp};
	font-size: 1.02rem;
	font-weight: 600;
	background: rgba(255, 255, 255, 0.055);
	box-shadow:
		inset 0 0 18px rgba(255, 255, 255, 0.045),
		0 0 18px rgba(176, 38, 255, 0.18);
	text-shadow: 0 0 14px rgba(255, 77, 242, 0.32);
	backdrop-filter: blur(14px);
	transition:
		border-color 160ms ease,
		box-shadow 160ms ease,
		transform 160ms ease,
		background 160ms ease;

	span {
		width: 16px;
		height: 16px;
		display: grid;
		place-items: center;
		color: #ff4df2;
		filter: drop-shadow(0 0 8px rgba(255, 77, 242, 0.75));
	}

	svg {
		width: 15px;
		height: 15px;
		fill: none;
		stroke: currentColor;
		stroke-width: 2;
		stroke-linecap: round;
		stroke-linejoin: round;
	}

	&:hover {
		transform: translateY(-1px);
		border-color: rgba(255, 77, 242, 0.48);
		background: rgba(255, 77, 242, 0.09);
		box-shadow:
			inset 0 0 18px rgba(255, 255, 255, 0.06),
			0 0 26px rgba(255, 77, 242, 0.26);
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		width: 100%;
		justify-content: center;
		min-height: 44px;
		font-size: 0.98rem;
	}
`;
